import { TabPanel, TabPanelProps } from '@chakra-ui/react'

import { createWidget } from '../widget-utils'

export interface TabWidgetProps extends TabPanelProps {
  caption?: string
  /**
   * @deprecated use fillContent
   */
  padding?: string
  /**
   * Whether or not to fill the content of the card with the children.
   * Removing content padding.
   */
  fillContent?: boolean
  isLoading?: boolean
}

export const TabWidget = ({
  children,
  caption,
  padding,
  fillContent,
  isLoading,
  ...props
}: TabWidgetProps) => {
  return (
    <TabPanel
      display="flex"
      flexDirection="column"
      flex="1"
      alignItems="stretch"
      padding={fillContent ? 0 : (padding ?? `24px 0 0 0`)}
      {...props}
    >
      {children}
    </TabPanel>
  )
}

export const TabWidgetDefinition = createWidget(TabWidget, {
  type: 'Tab',
})
